export type AuthReducer = {
  isGettingUser: boolean;
  isAuthenticated: boolean;
  errorMessage: string;
  showLogin: boolean;
  recentlyLoggedOut: boolean;
  utmChallenge: string;
  utmLink: string;
  clearUtm: boolean;
  ipBlocked: boolean;
};

export type AuthAction =
  | { type: "START_GETTING_USER" }
  | { type: "FINISH_GETTING_USER" }
  | { type: "GET_USER_FAIL"; error: string; showLogin: boolean }
  | { type: "LOGIN_SUCCESS" }
  | { type: "LOGIN_FAIL" }
  | { type: "LOGOUT" }
  | { type: "SET_UTM_LINK"; utm: string }
  | { type: "SET_UTM_CHALLENGE"; utm: string }
  | { type: "SET_CLEAR_UTM"; shouldClear: boolean }
  | { type: "IP_NOT_ALLOWED"; error: string };

const initialState: AuthReducer = {
  isGettingUser: false,
  isAuthenticated: false,
  errorMessage: "",
  showLogin: false,
  recentlyLoggedOut: false,
  utmChallenge: "",
  utmLink: "",
  clearUtm: false,
  ipBlocked: false,
};

function auth(state = initialState, action: AuthAction): AuthReducer {
  switch (action.type) {
    case "START_GETTING_USER":
      return { ...state, isGettingUser: true };
    case "FINISH_GETTING_USER":
      return { ...state, isGettingUser: false, errorMessage: "" };
    case "GET_USER_FAIL":
      return {
        ...state,
        errorMessage: action.error,
        isGettingUser: false,
        showLogin: action.showLogin,
      };
    case "LOGIN_SUCCESS":
      return {
        ...state,
        isAuthenticated: true,
        errorMessage: "",
        showLogin: false,
      };
    case "LOGIN_FAIL":
      return { ...state, isAuthenticated: false };
    case "LOGOUT":
      return {
        ...state,
        isAuthenticated: false,
        errorMessage: "",
        recentlyLoggedOut: true,
      };
    case "SET_UTM_LINK":
      return { ...state, utmLink: action.utm };
    case "SET_UTM_CHALLENGE":
      return { ...state, utmChallenge: action.utm };
    case "SET_CLEAR_UTM":
      return { ...state, clearUtm: action.shouldClear };
    case "IP_NOT_ALLOWED":
      return {
        ...state,
        isGettingUser: false,
        ipBlocked: true,
        errorMessage: action.error,
      };
    default:
      return state;
  }
}

export default auth;
